import { Component, EventEmitter, OnInit, Output, Input, ViewChild } from '@angular/core'
import { UserListGateway } from '../../gateways/user-list-gateway'
import { StateGateway } from '../../../common/gateways/state-gateway'
import { UserList } from '../../models/user-list'
import { UserSearch } from '../../models/user-search'
import { TrainingStatus } from '../../models/user-view'
import { FormValidationService } from '../../../validations/form-validation-service'
import { ValidatedSelectOptionModel } from '../../../validations/validated-dropdown.component'
import { ValidatedSelectOptionModel as State } from '../../../validations/validated-dropdown.component'
import { UserTypeGateway } from '../../gateways/user-type-gateway'
import { CurrentUser } from '../../../common/models/current-user'
import { HttpClient } from '@angular/common/http'
import { Router, ActivatedRoute, Params } from '@angular/router'
import { ExcelService } from '../../excel.services'
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid'
import { OrgTreeView } from '../../../common/components/orgTreeView/orgTreeViewDropdown.Component'
import { UserListToExcel } from '../../models/user-list-excel'
import { PortalGlobals } from '../../../portalglobals'
import { UserAccessGateway } from '../../../common/gateways/user-access-gateway'
import { UserListService } from './user-list.service'
import { UserGateway } from '../../gateways/user-gateway'
import { UserProfile } from '../../models/user-profile'
import { JqxGridVirtualPaging } from '../../../common/utilclasses/jqxgrid-virtualpaging'
import { OrgListContainerComponent } from '../../../reports/components/clients-report/org-list-container.component'
import { OrgSearchComponent } from '../../../reports/components/clients-report/org-search.component'
import { OrgBrowserView } from '../../../reports/models/org-browser-view'
import { MyClientsSavedSearch } from '../../../reports/models/myclients-saved-search'
@Component({
    selector: 'UserListVerOne',
    templateUrl: 'user-list-ver-one.component.html',
    styleUrls: ['user-list.component.scss']
})
export class UserListVerOneComponent implements OnInit {
    public loading = true
    @Input() currentUser: CurrentUser = {} as CurrentUser
    @ViewChild('TreeGrid', { static: true }) treeGrid11: jqxGridComponent
    @ViewChild('child') private child: OrgTreeView

    /* New Org View Start */
    @ViewChild('orgListContainer')
    private orgListContainer: OrgListContainerComponent

    @ViewChild('orgSearch')
    private orgSearch: OrgSearchComponent

    rootOrgId: number
    selectedSearch: MyClientsSavedSearch

    resetSearch: string
    selectedOrgValue: string = ''
    /* New Org View End */

    jqx: any
    // viewModel: OrgModel[]
    org1: any = []
    @Output() onValueChange: EventEmitter<UserList[]> = new EventEmitter<UserList[]>()

    listretriveModel: UserList[]
    listSearchModel: UserSearch
    listExportSearchModel: UserSearch
    @Input() states: State[]
    userType: ValidatedSelectOptionModel[]
    org: ValidatedSelectOptionModel[]
    parentOrgs: ValidatedSelectOptionModel[]
    listretriveModelList: UserList[]
    totalCount: number = 0
    chunkSize: number = 10000
    public data: string
    public mode: string
    public strAny: string
    listStatus: ValidatedSelectOptionModel[]
    exportUserList: UserListToExcel[]
    jqxgridvirtualpaging: JqxGridVirtualPaging
    public skipCall: boolean
    public trainingyears: number[]
    training1: string
    training2: string
    public loginidtxt: string
    user: any = {} as any
    viewUserProfile: UserProfile = {} as UserProfile
    isAllowAddUser: boolean
    isAllowEditUser: boolean
    selectedYear: number

    trainingStatus: ValidatedSelectOptionModel[] = [
        { text: 'Any', value: TrainingStatus.ANY },
        { text: 'Passed', value: TrainingStatus.PASSED },
        { text: 'Failed', value: TrainingStatus.FAILED },
        { text: 'Incomplete', value: TrainingStatus.INCOMPLETE },
        { text: 'Not Attempted', value: TrainingStatus.NOTATTEMPTED }
    ]

    listTrainingStatus: ValidatedSelectOptionModel[] = this.trainingStatus.slice()
    listagentdetails: UserList[] = [] as UserList[]
    userSearched: string

    public displayData: boolean
    public displayEmptyData: boolean
    public ExportAllAgentVisible: boolean
    isPreviousSearch: boolean
    icName: string

    source: any = {
        dataFields: [
            { name: 'TotalRecords', type: 'number' },
            { name: 'UserProfileID', type: 'number' },
            { name: 'LoginID', type: 'string' },
            { name: 'FirstName', type: 'string' },
            { name: 'userType', type: 'string' },
            { name: 'status', type: 'string' },
            { name: 'training1', type: 'string' },
            { name: 'training2', type: 'string' },
            { name: 'orgName', type: 'string' }
        ],

        dataType: 'json',
        id: 'UserProfileID',
        localData: this.org1,
        totalrecords: this.totalCount
    }
    dataAdapter = new jqx.dataAdapter(this.source)
    // selectionmode: 'singlecell'
    columns = [
        {
            text: 'Login ID',
            dataField: 'LoginID',
            width: 150,
            cellsRenderer: function (row, columnfield, value, id) {
                //console.log("row:" + row + "columnfield:" + columnfield + "value:" + value + "id:" + id)
                //console.log()
                //return '<a href =#/user-management/edit-user/edit/' + id + '> ' + value + '</a>'
                return '<a>' + value + '</a>'
            }
        },
        { text: 'Name', dataField: 'FirstName', width: 220 },
        { text: 'User Type', dataField: 'userType', width: 180 },
        { text: 'Status', dataField: 'status', width: 90 },
        { text: 'training1', dataField: 'training1', width: 140 },
        { text: 'training2', dataField: 'training2', width: 140 },
        { text: 'Org Hierarchy', dataField: 'OrganizationLists', width: 550, cellsformat: 'c2' },
        { text: 'UserProfileID', dataField: 'UserProfileID', hidden: true }
    ]
    constructor(
        formValidationService: FormValidationService,
        private userListGateway: UserListGateway,
        private _userGateway: UserGateway,
        private userTypeGateway: UserTypeGateway,
        private _stateGateway: StateGateway,
        public http: HttpClient,
        private excelService: ExcelService,
        private userListService: UserListService,
        private router: Router,
        private route: ActivatedRoute,
        public _global: PortalGlobals,
        private _networkUserAccessGateway: UserAccessGateway
    ) {
        this.listSearchModel = {} as UserSearch
        this.listExportSearchModel = {} as UserSearch
        this.listretriveModelList = {} as UserList[]
        this.exportUserList = {} as UserListToExcel[]
        this.mode = 'edit'
        this.strAny = 'Any'
        this.displayEmptyData = true
        this.isPreviousSearch = false
        this.displayData = true
        this.ExportAllAgentVisible = false
        this.jqxgridvirtualpaging = new JqxGridVirtualPaging()
        this._networkUserAccessGateway.getCurrentUser().subscribe((user) => {
            if (user != null) {
                this.currentUser = user
                this.icName = this.currentUser.insuranceCompanyName
                this.rootOrgId = parseInt(this.currentUser.orgId, 10)
                this.showOrgDropDown()
            }
        })
        this.loginidtxt = 'Login ID / Email / Name / NPN / Phone / Cell'
    }
    showOrgDropDown(): void {
        setTimeout(() => {
            if (this.orgListContainer !== undefined && this.orgListContainer !== null) {
                this.orgListContainer.initOrgTree(parseInt(this.currentUser.orgId, 10))
            }
        }, 1000)
        //this.createNewSearch();
    }

    ExportAll(): void {
        console.log('export call: ')
        // WebApi
        // Roleid

        this.getUserList()
        //  this.treeGrid.exportData('xml')
    }

    Cellclick(event: any): void {
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        if (event.args.datafield === 'LoginID') {
            this.setSearchParameters(this.listSearchModel)
            console.log('userid: ' + event.args.row.bounddata.UserProfileID)

            if (this.icName === this._global.insuranceCompanyNameNEJE) {
                this.router.navigate(['/' + insCo + '/user-management/neje/add-profile/edit/' + event.args.row.bounddata.UserProfileID])
            } else {
                /**
                 * comments: NA - 05-21-2019
                 * This conidition is used for Aetna organizations.
                 * We are not allowing the users to update their profile if user is belongs to Aetna orgs on the basis of the LockEditUsers Flag
                 * If user type is  org admin, org manager or admin agents
                 */
                this._userGateway.retrieveUser(event.args.row.bounddata.UserProfileID).subscribe((model) => {
                    this.user = model
                    this.viewUserProfile = this.user.UserProfile

                    this._networkUserAccessGateway.IsAllowtoEditUser(this.currentUser.userProfileName).subscribe((isallow: boolean) => {
                        this.isAllowEditUser = isallow
                        if (this.isAllowEditUser !== undefined && this.isAllowEditUser !== null) {
                            if (this.isAllowEditUser === true) {
                                this.router.navigate(['/' + insCo + '/user-management/edit-user/edit/' + event.args.row.bounddata.UserProfileID])
                            } else if (this.isAllowEditUser === false) {
                                if (this.viewUserProfile.LockEditUsers === true) {
                                    this.router.navigate([
                                        '/' + insCo + '/user-management/view-profile/' + event.args.row.bounddata.UserProfileID + '/1'
                                    ])
                                } else {
                                    this.router.navigate(['/' + insCo + '/user-management/edit-user/edit/' + event.args.row.bounddata.UserProfileID])
                                }
                            } else this.router.navigate(['/' + insCo + '/user-management/edit-user/edit/' + event.args.row.bounddata.UserProfileID])
                        } else {
                            if (this.viewUserProfile.LockEditUsers === true) {
                                this.router.navigate(['/' + insCo + '/user-management/view-profile/' + event.args.row.bounddata.UserProfileID + '/1'])
                            } else {
                                this.router.navigate(['/' + insCo + '/user-management/edit-user/edit/' + event.args.row.bounddata.UserProfileID])
                            }
                        }
                    })
                })
            }
        }
    }

    generateData(startindex: number, endindex: number): any {
        alert(startindex + ' test ' + endindex)
        let data = {}
        this.userListGateway.retrieveUserListData(this.listSearchModel).subscribe((model: UserList[]) => {
            //    console.table(model)

            this.listretriveModel = model
            // this.displayEmptyData = true
            //  this.displayData = false
            //this.org1 = model
            //this.source.localdata = this.org1
            //this.dataAdapter.dataBind()
            //this.treeGrid.updatebounddata()
        })
        for (let i = startindex; i < endindex; i++) {
            let row = {}

            row['UserProfileID'] = this.listretriveModel[i].UserProfileID
            row['LoginID'] = this.listretriveModel[i].LoginID
            row['FirstName'] = this.listretriveModel[i].FirstName
            row['userType'] = this.listretriveModel[i].userType
            row['status'] = this.listretriveModel[i].status
            row['training1'] = this.listretriveModel[i].training1
            row['training2'] = this.listretriveModel[i].training2
            row['orgName'] = this.listretriveModel[i].OrganizationLists
            data[i] = row
        }
        return data
    }

    //    As a Org-Admin, Org Manager or Agent Admin for "CVSHealth-Aetna" or  a downline org.
    //When i navigate to "Tools" -> "User Management"
    //Then  i should not see the button "Add New User"
    ngOnInit(): void {
        if (this.currentUser !== null && this.currentUser !== undefined && this.currentUser.insuranceCompanyName !== undefined) {
            this.icName = this.currentUser.insuranceCompanyName
            this.setLoginTiltle()
            this.setOnItValue()
            this.IsAllowtoAddUser()
            this.loading = false
        } else {
            this._networkUserAccessGateway.getCurrentUser().subscribe((currentUserModel: CurrentUser) => {
                this.currentUser = currentUserModel
                this.icName = this.currentUser.insuranceCompanyName
                this.setLoginTiltle()
                this.setOnItValue()
                this.IsAllowtoAddUser()
                this.loading = false
            })
        }
        // this.getTrainingyear()
    }
    IsAllowtoAddUser() {
        this._networkUserAccessGateway.IsAllowtoAddUser(this.currentUser.orgId, this.currentUser.userProfileName).subscribe((isallow: boolean) => {
            this.isAllowAddUser = isallow
        })
    }
    setOnItValue() {
        this.getSearchParameters()
        this.route.params.forEach((params: Params) => {
            if (params['isUserSearched'] !== undefined && params['isUserSearched'] === 'user-search') {
                this.isPreviousSearch = true
                if (this.listSearchModel !== undefined || this.listSearchModel !== null) {
                    if (this.listSearchModel.roleID !== undefined) {
                        this.setSearchParameters(this.listSearchModel)

                        this.setSearchParams()
                    } else {
                        this.isPreviousSearch = false
                        this.setDefaultSearch()
                    }
                } else {
                    this.isPreviousSearch = false
                    this.setDefaultSearch()
                }
            } else {
                this.isPreviousSearch = false
                this.setSearchParameters({} as UserSearch)
                this.setDefaultSearch()
            }
            this.getTrainingyear()
        })
    }
    setLoginTiltle() {
        if (this.icName === this._global.insuranceCompanyNameNEJE) {
            this.loginidtxt = 'Login ID / Email / Name '
        } else {
            this.loginidtxt = 'Login ID / Email / Name / NPN / Phone / Cell'
        }
    }

    setDefaultSearch() {
        this.getState()
        this.getUserTypes()

        this.getUserProfileStatus(true)
        this.getParentsOrg()

        this.getDefautvalues()
        this.displayEmptyData = true
        this.displayData = true
    }

    setSearchParams() {
        this.getState()
        this.getUserTypes()
        this.getUserProfileStatus(true)
        this.getParentsOrg()
        this.displayEmptyData = true
        this.displayData = true
    }

    getSearchParameters() {
        this.listSearchModel = this.userListService.getUserSearchParameters()
    }

    setSearchParameters(searchParameters: UserSearch) {
        this.userListService.setUserSearchParameters(searchParameters)
    }

    getState(): void {
        if (this.icName === this._global.insuranceCompanyNameNEJE) {
            this._stateGateway.getAllStatesforMailing().subscribe((states: State[]) => {
                this.states = states
                this.states.unshift({ text: 'Any', value: '0' })
                if (this.isPreviousSearch === undefined && !this.isPreviousSearch) {
                    this.listSearchModel.stateAbbr = '0'
                }
            })
        } else {
            this._stateGateway.getAllStates().subscribe((states: State[]) => {
                this.states = states
                this.states.unshift({ text: 'Any', value: '0' })
                if (this.isPreviousSearch === undefined && !this.isPreviousSearch) {
                    this.listSearchModel.stateAbbr = '0'
                }
            })
        }
    }

    getUserTypes() {
        this.userTypeGateway.getUserBasedRole().subscribe((userTypemodel: ValidatedSelectOptionModel[]) => {
            this.userType = userTypemodel
            this.userType.unshift({ value: '0', text: 'Any' })
            if (this.isPreviousSearch === undefined && !this.isPreviousSearch) {
                this.listSearchModel.roleID = 0
            }
        })
    }

    getOrganizations() {
        this.userTypeGateway.getAllOrganization().subscribe((orgModel: ValidatedSelectOptionModel[]) => {
            this.org = orgModel
        })
    }
    getParentsOrg() {
        this.userTypeGateway.getFMO().subscribe((model: ValidatedSelectOptionModel[]) => {
            this.parentOrgs = model
            this.parentOrgs.unshift({ value: '0', text: 'Any' })
            if (this.isPreviousSearch === undefined && !this.isPreviousSearch) {
                this.listSearchModel.orgID = 0
            }
            if (this.isPreviousSearch !== undefined && this.isPreviousSearch) {
                this.searchForm()
            }
        })
    }
    getDefautvalues() {
        this.listSearchModel.status = '0'
        this.listSearchModel.stateAbbr = '0'
        this.listSearchModel.roleID = 0
        this.listSearchModel.orgID = 0
        this.listSearchModel.training1 = TrainingStatus.ANY
        this.listSearchModel.training2 = TrainingStatus.ANY
        this.listSearchModel.SortFields = ''
        this.listSearchModel.FilterCriteria = ''
        this.listSearchModel.PageNumber = 1
        this.listSearchModel.PageSize = 50
        this.listSearchModel.searchcriteria = ''
    }
    getUserProfileStatus(retrieveAll: boolean) {
        this.userTypeGateway.getAllUserProfileStatus(true).subscribe((listStatusModel: ValidatedSelectOptionModel[]) => {
            this.listStatus = listStatusModel
            this.listStatus.unshift({ value: '0', text: 'Any' })
            if (this.isPreviousSearch === undefined && !this.isPreviousSearch) {
                this.listSearchModel.status = '0'
            }
        })
    }

    exportToExcel(): void {
        this.loading = true
        this.listExportSearchModel = this.listSearchModel
        this.listExportSearchModel.FilterCriteria = ''
        this.listExportSearchModel.SortFields = ''
        this.listExportSearchModel.PageNumber = 1
        this.listExportSearchModel.PageSize = this.totalCount
        this.userListGateway.retrieveExcelUserListData(this.listSearchModel).subscribe(
            (model: UserListToExcel[]) => {
                // model.slice()
                this.exportUserList = model
                // this.exportUserList.find()
                this.excelService.exportAsExelFormatted(this.exportUserList, 'AgentList', this.listSearchModel.year1, this.listSearchModel.year2)
                this.loading = false
            },
            (err) => {
                this.loading = false
            }
        )
    }

    onKeyDown(event) {
        const ENTER_KEY = 13
        if (event.keyCode === ENTER_KEY) {
            this.searchForm()
        }
    }

    searchForm(): void {
        this.displayEmptyData = true
        this.displayData = true

        //Reset Export All Agents visibility to false
        this.ExportAllAgentVisible = false

        this.loading = true

        if (this.listSearchModel.orgID !== undefined && this.listSearchModel.orgID !== null && this.listSearchModel.orgID !== 0) {
            this.ExportAllAgentVisible = true

            sessionStorage.setItem('OrgSelected', 'true')
        } else {
            sessionStorage.removeItem('OrgSelected')
        }
        this.listSearchModel.PageNumber = 1
        this.listSearchModel.PageSize = 50
        this.listSearchModel.FilterCriteria = ''
        this.listSearchModel.SortFields = ''
        if (this.treeGrid11 !== null && this.treeGrid11 !== undefined) {
            //Workaround to stop triggering of OnFilter and OnSort event, when filters and sort are cleared
            this.skipCall = true
            this.treeGrid11.clearfilters()
            this.treeGrid11.removesort()
        }

        this.userListGateway.retrieveUserListData(this.listSearchModel).subscribe(
            (model: UserList[]) => {
                if (model !== null && model.length !== 0) {
                    this.loading = false
                    this.listretriveModel = model
                    this.displayEmptyData = true
                    this.displayData = false

                    this.org1 = model
                    this.source.localdata = this.org1
                    this.totalCount = model[0].TotalRecords
                    this.source.totalrecords = model[0].TotalRecords
                    this.dataAdapter.dataBind()
                    this.treeGrid11.updatebounddata()
                    this.skipCall = false
                    this.loading = false
                    //if (this.treeGrid11 !== null && this.treeGrid11 !== undefined)
                    //    this.treeGrid11.localizestrings(this.jqxgridvirtualpaging.ready());
                } else {
                    this.displayEmptyData = false
                    this.displayData = true
                    this.loading = false
                    this.skipCall = false
                }
            },
            (err) => {
                this.loading = false
            }
        )
    }

    getAgentList(): void {
        // this.treeGrid.exportdata('xls', 'Agents')
        this.loading = true
        let _orgID = this.listSearchModel.orgID
        let year1 = this.listSearchModel.year1
        let year2 = this.listSearchModel.year2
        this.http.get<UserList[]>('../api/getAllAgentsDetails/' + _orgID + '/' + year1 + '/' + year2).subscribe(
            (data) => {
                this.listagentdetails = data
                this.excelService.exportAsExcelFile(this.listagentdetails, 'Agents', this.listSearchModel.year1, this.listSearchModel.year2)
                this.loading = false
            },
            (err) => {
                this.loading = false
            }
        )
    }

    getUserList(): void {
        this.displayEmptyData = true
        this.displayData = true
        this.userListGateway.getUserList().subscribe((data: UserList[]) => {
            this.listretriveModelList = data
            //   console.table(this.listretriveModelList)
        })
    }

    clearForm(): void {
        // this.listSearchModel = {} as UserSearch
        this.displayData = true
        this.displayEmptyData = true
        this.child.onDataLoad('')
        this.getDefautvalues()
    }

    ready = (): void => {
        console.log()
        this.treeGrid11.localizestrings(this.jqxgridvirtualpaging.ready())
    }

    updatefilterconditions = (type: string, defaultconditions: any): string[] | undefined => {
        return this.jqxgridvirtualpaging.updatefilterconditions(type)
    }

    onSort(event: any): void {
        if (!this.skipCall) {
            this.skipCall = true
            this.loading = true
            this.listSearchModel.SortFields = this.jqxgridvirtualpaging.onSort(event)
            //  this.listSearchModel.SortOrd = this.jqxgridvirtualpaging.getSortField(event)
            let userListData = this.userListGateway.retrieveUserListDataSync(this.listSearchModel)
            if ((userListData !== null || userListData !== undefined) && userListData.length > 0) {
                this.listretriveModel = userListData
                this.source.localData = userListData
                this.source.totalrecords = userListData[0].TotalRecords
                this.dataAdapter.dataBind()
                this.treeGrid11.updatebounddata()
            }
            this.skipCall = false
            this.loading = false
        }
    }

    onPageSizeChanged(event: any): void {
        //alert('asdf')
        //   this.loading = true
        let args = event.args
        this.source.pagesize = this.listSearchModel.PageSize = args.pagesize
        let userListData: UserList[] = this.userListGateway.retrieveUserListDataSync(this.listSearchModel)
        if ((userListData !== null || userListData !== undefined) && userListData.length > 0) {
            this.listretriveModel = userListData
            this.source.localData = userListData
            this.skipCall = true
            this.dataAdapter.dataBind()
            this.treeGrid11.updatebounddata()
            this.skipCall = false
        }
        //this.loading = false
    }

    onFilter(event: any): void {
        if (!this.skipCall) {
            this.skipCall = true
            //   this.loading = true
            let filterinfo = this.treeGrid11.getfilterinformation()
            this.listSearchModel.FilterCriteria = this.jqxgridvirtualpaging.onFilter(event, filterinfo)

            let userListData: UserList[] = this.userListGateway.retrieveUserListDataSync(this.listSearchModel)
            if ((userListData !== null || userListData !== undefined) && userListData.length > 0) {
                this.listretriveModel = userListData
                this.source.localData = userListData
                this.source.totalrecords = userListData[0].TotalRecords
                this.dataAdapter.dataBind()
                this.treeGrid11.updatebounddata()
            } else {
                this.displayEmptyData = false
                this.displayData = true
                // this.loading = false;
            }
            // this.loading = false
            this.skipCall = false
        }
    }

    rendergridrows = (params: any): any[] | undefined => {
        if (!isNaN(params.startindex)) {
            let newPageNumber = Math.floor(params.startindex / this.listSearchModel.PageSize) + 1

            this.listSearchModel.PageNumber = Math.floor(params.startindex / this.listSearchModel.PageSize) + 1

            if (!this.skipCall) {
                console.log('rendergird')
                this.listretriveModel = this.userListGateway.retrieveUserListDataSync(this.listSearchModel)
            }

            return this.listretriveModel
        }
    }

    getTrainingyear(): void {
        this.selectedYear = this._global.selectedPlanYear

        this.userListGateway.getTrainingYears(this.selectedYear).subscribe((model: number[]) => {
            //    console.table(model)

            this.trainingyears = model
            this.listSearchModel.year1 = this.trainingyears[0].toString()
            this.listSearchModel.year2 = this.trainingyears[1].toString()
            this.training1 = 'Training ' + this.trainingyears[0].toString()
            this.training2 = 'Training ' + this.trainingyears[1].toString()
            this.changeTrainingHeader()
            console.log(this.trainingyears)
        })
    }
    changeTrainingHeader(): void {
        for (var i = 0; i < this.columns.length; i++) {
            var row = this.columns[i]
            console.log(row['text'].toString())
            if (row['text'] == 'training1') {
                row['text'] = this.training1
            }
            if (row['text'] == 'training2') {
                row['text'] = this.training2
            }
        }
    }

    redirectForm(): void {
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        if (this.icName === this._global.insuranceCompanyNameNEJE) {
            this.router.navigate(['/' + insCo + '/user-management/neje/add-profile/add'])
        } else {
            this.router.navigate(['/' + insCo + '/user-management/user'])
        }
    }

    onOrgSelected(org: OrgBrowserView): void {
        this.listSearchModel.orgID = org.orgId
        //this.addOrg(org);
    }
}
